/**
 * checkout.ts — Zod schemas for the checkout flow.
 *
 * Extracted from worker/src/routes/checkout.ts (2026-05-12) when the Fastify
 * HTTP layer was removed from the worker (now a headless reactor).
 *
 * These schemas will be reused when checkout is re-implemented as a web-app
 * API route (Next.js API routes or a dedicated Fastify service alongside the
 * client app).
 */

import { z } from 'zod';
import { Cart } from './cart.js';

/**
 * Customer fields a-manager needs in addition to the cart payload.
 * Collected by the client checkout form, not stored anywhere on our side.
 */
export const CheckoutCustomer = z.object({
  email: z.string().email(),
  phone: z.string().optional(),
  imie: z.string().min(1),
  nazwisko: z.string().min(1),
  adres: z.object({
    ulica: z.string().min(1),
    miasto: z.string().min(1),
    kod: z.string().min(1),
    kraj: z.string().length(2),
  }),
});
export type CheckoutCustomer = z.infer<typeof CheckoutCustomer>;

export const CheckoutBody = z.object({
  cart: Cart,
  customer: CheckoutCustomer,
  /** a-manager numeric site id; legacy tapetka.pl = 41. */
  amanager_site: z.number().int().positive().default(41),
});
export type CheckoutBody = z.infer<typeof CheckoutBody>;
